<template>
    <div class="d-inline-block">
        <v-btn
            :fab="buttonIcon.length > 0"
            :color="color"
            @click.stop="confirmDialog = true"
            dark
            :small="small"
            :depressed="depressed"
            v-on="on"
            class="mx-1"
            :loading="loading"
            :disabled="loading"
        >
            <v-icon v-if="buttonIcon">{{ buttonIcon }}</v-icon>
            <template v-if="buttonText">{{ buttonText }}</template>
        </v-btn>
        <v-dialog
            v-model="confirmDialog"
            :width="dialogWidth"
        >
            <v-card :color="isAja ? '#1E3945' : ''">
                <!-- Header avec icône -->
                <v-card-title :class="['py-4', isAja ? 'aja-header' : 'primary']" class="white--text">
                    <v-icon class="mr-3 white--text">check_circle</v-icon>
                    <span class="title">Confirmation</span>
                </v-card-title>

                <!-- Message principal -->
                <v-card-text :class="['pt-5 pb-3 px-5 subtitle-1', {'white--text': $vuetify.theme.dark || isAja, 'black--text': !$vuetify.theme.dark && !isAja}]">
                    {{ headline }}
                </v-card-text>

                <!-- Zone d'information (si subtext) -->
                <v-card-text v-if="subtext" class="pt-0 pb-4 px-5">
                    <v-alert
                        :color="isAja ? '#4E983C' : 'primary'"
                        border="left"
                        colored-border
                        elevation="1"
                        dense
                        class="white--text"
                        :style="isAja ? {'background-color': '#294D5B'} : {}"
                    >
                        <div class="d-flex align-start">
                            <v-icon :color="isAja ? '#4E983C' : 'primary'" class="mr-3 mt-1">info</v-icon>
                            <div class="body-2" v-html="subtext"></div>
                        </div>
                    </v-alert>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4">
                    <v-btn
                        color="secondary"
                        @click="confirmDialog = false"
                        :disabled="loading"
                        outlined
                    >
                        Annuler
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        :color="isAja ? '#4E983C' : 'primary'"
                        dark
                        @click="toconfirm"
                        :loading="loading"
                        :disabled="loading"
                    >
                        <v-icon left>check</v-icon>
                        {{ confirmText }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
export default {
    props: {
        on: { type: Object, default() {return {}} },
        color: { type: String, default: 'error' },
        small: { type: Boolean, default: false },
        depressed: { type: Boolean, default: false },
        headline: {type: String, default: 'Merci de confirmer cette action'},
        subtext: {type: String, default: ''},
        dialogWidth: {type: [String, Number], default: 500},
        buttonIcon: {type: String, default: ''},
        buttonText: {type: String, default: ''},
        confirmText: {type: String, default: 'Confirmer'},
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            confirmDialog: false,
        }
    },
    computed: {
        isAja() {
            return this.$store.getters.getProfile.is_aja
        }
    },
    methods: {
        toconfirm() {
            this.confirmDialog = false
            this.$emit('confirmed')
        }
    }
}
</script>

<style scoped>
.aja-header {
    background-color: #4E983C !important;
}
</style>